import { CalendarClock, X } from "lucide-react";
import { fmtScheduled } from "./BroadcastScheduleField";

/**
 * List of upcoming scheduled broadcasts with a per-row cancel button. Only
 * rendered when there's at least one item or the parent is still loading.
 */
export default function ScheduledBroadcastList({ items, loading, onCancel }) {
  if (items.length === 0 && !loading) return null;
  return (
    <div className="pt-4 border-t border-white/5">
      <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2 flex items-center gap-2">
        <CalendarClock size={14} /> Upcoming ({items.length})
      </div>
      <div className="space-y-2" data-testid="scheduled-broadcasts-list">
        {items.map((s) => (
          <div
            key={s.id}
            data-testid={`scheduled-broadcast-${s.id}`}
            className="flex items-start justify-between gap-3 bg-black/40 border border-white/5 px-3 py-2"
          >
            <div className="min-w-0 flex-1">
              <div className="text-sm text-white truncate">{s.subject}</div>
              <div className="text-[11px] text-rose-400">
                {fmtScheduled(s.scheduled_for)}
                {s.segment && s.segment !== "all" && (
                  <span className="ml-2 text-zinc-500">
                    · {s.segment === "desire" ? `desire: ${s.desire_tag}` : s.segment}
                  </span>
                )}
              </div>
            </div>
            <button
              onClick={() => onCancel(s.id)}
              className="text-zinc-500 hover:text-rose-500 transition-colors"
              data-testid={`cancel-scheduled-${s.id}`}
              title="Cancel"
            >
              <X size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
